module.exports = __webpack_public_path__ + "static/img/3.f571c0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/sp/3.png
// module id = Aib2
// module chunks = 0